// extracted by mini-css-extract-plugin
var _1 = "r5pyK";
var _2 = "TYot2";
export { _1 as "base", _2 as "header" }
